// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Divider{background:var(--divider)}.Divider.row{width:1px;height:20px;margin:4px 0;align-self:center}.Divider.column{width:auto;height:1px;margin:0 4px}", ""]);
// Exports
module.exports = exports;
